import api from './api';

const base = '/admin/procedimentos';

export async function listProcedimentos({ q = '', page = 1, limit = 25 } = {}) {
  const { data } = await api.get(base, { params: { q, page, limit } });
  return data;
}

export async function createProcedimento(payload) {
  const { data } = await api.post(base, payload);
  return data;
}

export async function updateProcedimento(codProcedi, payload) {
  const { data } = await api.put(`${base}/${codProcedi}`, payload);
  return data;
}

export async function deleteProcedimento(codProcedi) {
  const { data } = await api.delete(`${base}/${codProcedi}`);
  return data;
}
